export const START_TRIAL_MODAL_ID = 'start-trial-modal';
export const TRIAL_EXPIRED_MODAL_ID = 'trial-expired-modal';
export const UPGRADE_ACCESS_MODAL_ID = 'upgrade-access-modal';
